import L from 'leaflet'
import GeoServerOws from "./geoServerOws";

class GeoJsonUtil {
	//пересобирает объект собирая геометрии с одним ключом в коллекции геометрий
	static groupFeatures = (geoJson) => {
		const ungroupedFeatures = {};
		geoJson.features.map(function (feature) {
			const key = feature.properties["key"];
			if (key in ungroupedFeatures)
				ungroupedFeatures[key].push(feature);
			else
				ungroupedFeatures[key] = [feature];
		});
		geoJson.features = [];
		for (let key in ungroupedFeatures) {
			if (ungroupedFeatures.hasOwnProperty(key)) {
				if (ungroupedFeatures[key].length > 1) {
					let feature = ungroupedFeatures[key][0];
					//заменяем геометрию на коллекцию геометрий
					feature.geometry = {
						type: "GeometryCollection",
						geometries: ungroupedFeatures[key].map(function (item) {
							return item.geometry;
						})
					};
					geoJson.features.push(feature);
				} else
					geoJson.features.push(ungroupedFeatures[key][0]);
			}
		}
		return geoJson;
	};
}

export class LeafletMapSrsUtil {
	static fromLatLngToMapSrsPoint(latLng, leafletMap) {
		const projection = leafletMap.options.crs;
		let ll;
		if (!latLng.lat && latLng.lat > 0)
			ll = L.latLng(latLng[0], latLng[1]);
		else
			ll = latLng;
		return projection.project(ll);
	}
	
	static fromMapSrsPointToLatLng(point, leafletMap) {
		const crs = leafletMap.options.crs;
		let pp;
		if (!point.x)
			pp = L.point(point[0], point[1]);
		else
			pp = point;
		return crs.unproject ? crs.unproject(pp) : crs.projection.unproject(pp);		
	}
}

class LeafletMapViewUtil {
	static getVisibleBoxProjection(map) {
		const p1 = map.containerPointToLatLng(L.point(0, 0));
		const p2 = map.containerPointToLatLng(L.point(map.getContainer().clientWidth - 1, map.getContainer().clientHeight - 1));
		const mp1 = LeafletMapSrsUtil.fromLatLngToMapSrsPoint(p1, map);
		const mp2 = LeafletMapSrsUtil.fromLatLngToMapSrsPoint(p2, map);
		return [mp1.x, mp2.y, mp2.x, mp1.y];
	}

	static getVisibleBoxProjectionString(map) {
		const bbox = this.getVisibleBoxProjection(map);
		return bbox.join(',');
	}
}

const wmsRequestFeaturesCountLimit = 15;

const getFeaturesByPosition = function getFeaturesByPosition(map, layers, clientPoint, callbackFeature, callbackNotFound) {
	//IE Hack
	clientPoint.x = Math.round(clientPoint.x);
	clientPoint.y = Math.round(clientPoint.y);

	const totalFeatures = [];

	const searchInNextLayer = function (i) {
		if (i >= layers.length) {
			if (totalFeatures && totalFeatures.length && callbackFeature)
				callbackFeature(totalFeatures);
			else if (callbackNotFound)
				callbackNotFound();
			return;
		}
		const currentLayer = layers[i];
		if (currentLayer instanceof L.TileLayer) {
			getFeatureByWms(map, currentLayer, clientPoint,
				function (responseData) {
					try {
						var geoJson = GeoJsonUtil.groupFeatures(responseData);
						if (geoJson.features.length > 0){
							geoJson.features.forEach((f)=>{
								f.layer = currentLayer;
								totalFeatures.push(f);
							});
						}
							
					} catch (ee) {
						//console.log(ee);
					}
					searchInNextLayer(++i);
				},
				function () {
					searchInNextLayer(++i);
				});
		} else
			searchInNextLayer(++i);
	};
	searchInNextLayer(0);
};

const getFeatureByWms = function getFeatureByWmsWfs(map, layer, clientPoint, success, failure)
{
	var wmsParams = {
		service: 'wms',
		request: 'GetFeatureInfo',
		bbox: LeafletMapViewUtil.getVisibleBoxProjectionString(map),
		layers: layer.options.description.name,
		query_layers: layer.options.description.name,
		x: clientPoint.x,
		y: clientPoint.y,
		width: map.getContainer().clientWidth,
		height: map.getContainer().clientHeight,
		srs: map.options.crs.code,
		info_format: 'application/json',
		//propertyName: 'key,full_name,aliastype',//убрать если нужно не все свойства
		feature_count: wmsRequestFeaturesCountLimit
	};
	var regexMatch = layer._url.match('.*//[^/]*');
	var relativeUrl = regexMatch && regexMatch.length ? layer._url.replace(regexMatch[0], '') : layer._url;
	var wmsQueryUrl = relativeUrl.substring(0, relativeUrl.indexOf('gwc/service/wmts')) + 'wms' + L.Util.getParamString(wmsParams);

	GeoServerOws.get(wmsQueryUrl).then(wmsSuccess).catch(failure);

	function wmsSuccess(responseData) {
		if (!responseData || !responseData.features || !responseData.features.length) {
			failure('Не найдено объектов под курсором');
			return;
		}
		if (success)
			success(responseData);
	}
};

export const getFeatureByWfs = function getFeatureByWmsWfs(layerName, keys) {
	var wfsParams = {
		request: 'GetFeature',
		typeName: layerName,
		outputFormat: 'application/json',
		cql_filter: 'key in (' + keys.join(',') + ')'
	};
	
	var wfsQuery = '/map/tiles/wfs' +
		L.Util.getParamString(wfsParams);


	return GeoServerOws.get(wfsQuery);
};
export default {getFeaturesByPosition}